import React from 'react'
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import './pay.scss'
import axios from 'axios';
import { useParams } from "react-router-dom"
import CheckoutForm from '../checkoutform/CheckoutForm';
import { useState, useEffect } from "react"
import { Container } from 'react-bootstrap';
import { config } from '../../../config';
import AuthContext from "../../../contexts/AuthContext";

//const stripePromise = loadStripe("pk_test_51MntLhGyVBwpE3ITCtua3eawKNTDwAfCLuSsRPXBfLKXhQZxaoGwmbpkug4mnTEyrl3dTSwuuUShYqBbHlM5UQnp001IlAWIhu");
const stripePromise = loadStripe("pk_live_51MntLhGyVBwpE3ITwajhQlsw9IUDKsA9onFIWQ6dnhVhvAqTTO2s8H7ALAg2VSC6Ebfw4Cfw0D3ng6H0KSsCkROe00mFnHZlPz");

export const Pay = () => {
    const [clientSecret, setClientSecret] = useState("");

    const { value } = useParams()

    const {
        currentUser,
    } = React.useContext(AuthContext);

  
    useEffect(() => {
        console.log("Value:", value)
        let inputs = {
            user: currentUser,
            credits: value < 10 ? 100000 : 200000,
            payment: value
        }
        sessionStorage.removeItem("PaymentStatus")
        const makeRequest = async () => {
            try {
                const res = await axios.post(config.url.API_URL + '/deda_ai_api/pay/create_payment_intent_buy_credits', inputs);
                //console.log("Clientsecret:", res.data.clientSecret)
                setClientSecret(res.data.clientSecret)
            } catch (err) {
                console.log(err)
            }
        }

        makeRequest()
    }, [value, currentUser])

    const appearance = {
        theme: 'stripe',
    };
    const options = {
        clientSecret,
        appearance,
    };


    return (
        <div>
            
            <Container className="payContainer">
            
            

                <div className="pay">
               
                    <div className="card">
                    
                        
                        <div className="right">
                            {clientSecret && (
                                <Elements options={options} stripe={stripePromise}>
                                    <CheckoutForm value={value} />
                                </Elements>
                            )}
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    )
}

export default Pay
